import { useReturnContext } from '../../contexts/returnContext';
import { theme } from '../../utils/theme';
import Typography from '../atoms/Typography';
import Banner from '../molecules/Banner';

// Rejected reason question answers get their own text, with the server's messages as the detail.
const RegistrationFailedBanner = () => {
  const { reasonQuestionErrors } = useReturnContext();

  if (reasonQuestionErrors.length === 0) {
    return <Banner variant="error" message="registration_failed" />;
  }

  return (
    <Banner variant="error" message="reason_question_registration_failed">
      {[...new Set(reasonQuestionErrors)].map((message) => {
        return (
          <Typography key={message} variant="body2" color={theme.colors.grey[100]}>
            {message}
          </Typography>
        );
      })}
    </Banner>
  );
};

export default RegistrationFailedBanner;
